// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Training from './pages/Training';
import Courses from './pages/Courses';
import CivilEngineering from './pages/CivilEngineering';
import ComputerEngineering from './pages/ComputerEngineering';
import MarketingCommunication from './pages/MarketingCommunication';
import ElectricalEngineering from './pages/ElectricalEngineering';
import './App.css';

import { SpeedInsights } from '@vercel/speed-insights/react';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/apropos" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/formation/:department" element={<Training />} />
              <Route path="/formation" element={<Navigate to="/formation/informatique" replace />} />
              <Route path="/formation" element={<Training />} />
              <Route path="/cours-scolaire" element={<Courses />} />
              {/* Routes pour les sous-pages */}
              <Route path="/services/logiciel" element={<Services />} />
              <Route path="/services/marketing" element={<Services />} />
              <Route path="/services/electricite" element={<Services />} />
              <Route path="/services/btp" element={<Services />} />
              <Route path="/genie-civil" element={<CivilEngineering />} />
              <Route path="/genie-electrique" element={<ElectricalEngineering />} />
              <Route path="/genie-informatique" element={<ComputerEngineering />} />
              <Route path="/communication" element={<MarketingCommunication />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
      <SpeedInsights />
    </LanguageProvider>
    
  );
}

export default App;